// 页面名称枚举，用于标识页面组件
export const PAGE_NAME = {
  home: 'home', // 首页
  social: 'social', // 社招
  campus: 'campus', // 校招
  competition: 'competition', // 赛事
  positionList: 'positionList', // 职位列表
  positionDetail: 'positionDetail', // 职位详情
  deliverySuccess: 'deliverySuccess', // 投递成功
  deliveryConfirm: 'deliveryConfirm', // 投递确认
  personalCenter: 'personalCenter', // 个人中心
  login: 'login', // 登录页
  campusTV: 'campusTV', // 校招TV
  question: 'question', // 常见问题
  about: 'about', // 了解美团
  beiDou: 'beiDou', // 北斗计划
  qiHang: 'qiHang', // 起航计划
  trainee: 'trainee', // 食杂零售管培生计划
  longcat: 'longcat', // LongCat 大模型人才招
  sharePosition: 'sharePosition', // 分享职位落地页
  campusSchedule: 'campusSchedule', // 校招行程
  beidouProgram: 'beidouProgram', // 新北斗
  aiInterviewExam: 'aiInterviewExam', // AI面试考试
  news: 'news', // 新闻页
};

// 页面灵犀埋点cid
export const PAGE_CID = {
  [PAGE_NAME.home]: 'c_ead_nk2h6i8i',
  [PAGE_NAME.qiHang]: 'c_ead_gsnemt7i',
  [PAGE_NAME.trainee]: 'c_ead_gsnemt7i',
  [PAGE_NAME.longcat]: 'c_ead_7rjhssmj',
  [PAGE_NAME.campusTV]: 'c_ead_iqo1e86v',
  [PAGE_NAME.positionDetail]: 'c_ead_ous3r43j',
  [PAGE_NAME.deliveryConfirm]: 'c_ead_q92dsetx',
  [PAGE_NAME.deliverySuccess]: 'c_ead_9rc6owej',
  [PAGE_NAME.campus]: 'c_ead_do49iebq',
  [PAGE_NAME.competition]: 'c_ead_9rc6owej',
  [PAGE_NAME.social]: 'c_ead_kjdgcjoz',
  [PAGE_NAME.beiDou]: 'c_ead_j254p74h',
  [PAGE_NAME.positionList]: 'c_ead_bwdwkk7r',
  [PAGE_NAME.login]: 'c_ead_nrikjrsf',
  [PAGE_NAME.sharePosition]: 'c_ead_ik965py4',
  [PAGE_NAME.about]: 'c_ead_i1hcbsm6',
  [PAGE_NAME.beidouProgram]: 'c_ead_kteex9oh',
};

// 页面title 名称cid
export const PAGE_TITLE = {
  [PAGE_NAME.home]: '首页 | 美团招聘',
  [PAGE_NAME.social]: '社会招聘 | 美团招聘',
  [PAGE_NAME.campus]: '校园招聘 | 美团招聘',
  [PAGE_NAME.competition]: '美团赛事 | 美团招聘',
  [PAGE_NAME.positionList]: '职位列表 | 美团招聘',
  [PAGE_NAME.positionDetail]: '职位详情 | 美团招聘',
  [PAGE_NAME.login]: '登录 | 美团招聘',
  [PAGE_NAME.about]: '了解美团 | 美团招聘',
  [PAGE_NAME.question]: '常见问题 | 美团招聘',
  [PAGE_NAME.personalCenter]: '个人中心 | 美团招聘',
  [PAGE_NAME.beiDou]: '北斗计划 | 美团招聘',
  [PAGE_NAME.qiHang]: '零售启航计划 | 美团招聘',
  [PAGE_NAME.trainee]: '食杂零售管培生计划 | 美团招聘',
  [PAGE_NAME.longcat]: 'LongCat大模型人才校招 | 美团招聘',
  [PAGE_NAME.campusTV]: '校招TV | 美团招聘',
  [PAGE_NAME.campusSchedule]: '校招行程 | 美团招聘',
  [PAGE_NAME.sharePosition]: '职位列表 | 美团招聘',
  [PAGE_NAME.beidouProgram]: '北斗计划 | 美团招聘',
  [PAGE_NAME.aiInterviewExam]: '美团招聘',
  [PAGE_NAME.news]: '美团新闻 | 美团招聘',
};

// 简历或投递渠道
export const SOURCE_TYPE = {
  campus: '12',
  campusWeChat: '14',
  campusBole: '15',
  campusWeChatBole: '16',
  campusWeChatBoleQRCode: '25',
  social: '11',
  socialWeChat: '13',
  socialBole: '17',
  socialWeChatBole: '18',
  socialWeChatBoleQRCode: '23',
};

export const LX_RESUME_EDIT_MODULE_VIEW = {
  uploadResume: 'b_ead_qcyzx5xl_mv',
  eduExperience: 'b_ead_3oqgjjlp_mv',
  workExperience: 'b_ead_ry1efpa5_mv',
  projectExperience: 'b_ead_3gdo7ljg_mv',
  campusExperience: 'b_ead_lrpz8c5k_mv',
  honor: 'b_ead_arcuwxjz_mv',
  languageStandard: 'b_ead_c0clpk0j_mv',
  certificate: 'b_ead_2ys46wkm_mv',
  skillStandard: 'b_ead_7kssx0jw_mv',
  paper: 'b_ead_pkwrvnod_mv',
  competition: 'b_ead_5fd207ln_mv',
  sampleReels: 'b_ead_t63j57on_mv',
  patent: 'b_ead_1kixdtbs_mv',
  exam: 'b_ead_umgkvukj_mv',
  socialAccount: 'b_ead_e7rwiqhf_mv',
  selfDescription: 'b_ead_b2p9hxfv_mv',
};

export const LX_RESUME_EDIT_MODULE_ADD = {
  uploadResume: 'b_ead_hul3hhqp_mc',
  resumeEduExpList: 'b_ead_sw4xbe15_mc',
  resumeWorkExpList: 'b_ead_timw684c_mc',
  resumeProjectExpList: 'b_ead_3gdo7ljg_mv',
  resumeCampusExpList: 'b_ead_cuf72l3t_mc',
  resumeHonorList: 'b_ead_m0zhqoy4_mc',
  resumeLanguageList: 'b_ead_4pmj6twq_mc',
  resumeCertificateList: 'b_ead_2k3wxtwt_mc',
  resumeSkillList: 'b_ead_4l8v3x1l_mc',
  resumeThesisList: 'b_ead_1mt8npu6_mc',
  resumeCompetitionList: 'b_ead_seh2tfwd_mc',
  resumeWorksAttachmentList: 'b_ead_0z5mjh6v_mc',
  resumePatentList: 'b_ead_lo89zjrr_mc',
  resumeExamList: 'b_ead_lxhlo2y1_mc',
  resumeSocialAccountList: 'b_ead_evsu5h1e_mc',
  // TODO： 需要确认是不是要添加自我描述
};

export const LX_RESUME_EDIT_MODULE_DELETE = {
  uploadResume: '',
  resumeEduExpList: 'b_ead_58kqxfea_mc',
  resumeWorkExpList: 'b_ead_w1mmnn6k_mc',
  resumeProjectExpList: 'b_ead_440wuni9_mc',
  resumeCampusExpList: 'b_ead_bahopjga_mc',
  resumeHonorList: 'b_ead_js1bylvx_mc',
  resumeLanguageList: 'b_ead_3dzw3raz_mc',
  resumeCertificateList: 'b_ead_ht1kl1ax_mc',
  resumeSkillList: 'b_ead_ty23yw79_mc',
  resumeThesisList: 'b_ead_lw7qdu2m_mc',
  resumeCompetitionList: 'b_ead_xq7z8lqv_mc',
  resumePatentList: 'b_ead_0cpz9mpa_mc',
  resumeExamList: 'b_ead_ixpowpug_mc',
  resumeSocialAccountList: 'b_ead_p0v2vatq_mc',
  // TODO： 需要确认是不是要添加自我描述
};

export const LX_RESUME_EDIT = {
  resumeEditView: 'c_ead_k47383tg',
  resumeEditSave: 'b_ead_enq4nzqh_mc',
  switchToSocial: 'b_ead_c2qq1ppm_mc',
  switchToCampus: 'b_ead_ex8bdacr_mc',
};

export const LX_RESUME = {
  emptyView: 'b_ead_9rmkiv3a_mv',
  resumeCreate: 'b_ead_al8n3dmm_mc',
  typeSelectView: 'b_ead_g3j165wo_mv',
  selectCampus: 'b_ead_0vvs2o5k_mc',
  selectSocial: 'b_ead_mjvqqgyv_mc',
  resumeView: 'c_ead_kngvaln0',
  resumeEdit: 'b_ead_qwa5h30r_mc',
};

export const LX_SEARCH_CLICK = {
  home: 'b_ead_se8dazfa_mc',
  social: 'b_ead_c42sa8zf_mc',
  campus: 'b_ead_kxp282up_mc',
  about: 'b_ead_n1bjmhzb_mc',
  position: 'b_ead_s1pde7rx_mc',
};

export const num2Chinese = {
  0: '零',
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九',
};

export const INTENTION_JOB = 'intentionJob';
export const INTENTION_BG = 'interestBG';
export const WORK_CITY_LIST = 'workCityList';
export const WORK_DIRECTION = 'aspirationDirectionCodeList';
export const DEPARTMENT_CUSTOM_ID = 'customId000';
export const DIRECTION_CUSTOM_ID = '-1';

/**
 * @description: 职位申请错误码
 */
export const applyErrorCode = {
  /**
   * @description: 有意向职位毕业时间不满足
   */
  code10001: '10001',
  /**
   * @description: 无意向职位毕业时间不满足
   */
  code10002: '10002',
};

export const RESUME_EDITOR_CALLER = {
  resumeDetail: 'resumeDetail',
  deliveryConfirm: 'deliveryConfirm',
};

export const LX_SEARCH_OVERSEAS_CITY_PATH = {
  '/m/social': 'b_ead_0nx8b8tj_mc',
  '/m/campus': 'b_ead_n8icjo7m_mc',
};

/**
 * @description: 学历代码枚举
 */
export const DEGREE_CODE = {
  /** 大学专科 */
  COLLEGE: '67',
  /** 大学本科 */
  BACHELOR: '68',
};

export const enum AICodingWorkSource {
  NOCODE = 'nocode',
  OTHER = 'other',
}

export const enum AICodingStatus {
  UN_COMPLETE = 0,
  COMPLETED = 1,
  EXPIRED = 2,
}
